import { LocalNavigation as LocalNavigationComponent } from '@almbrand/localnavigation';
import { LocalNavigationTopPositionContext } from 'context/LocalNavigationTopPositionContext';

import { useContext } from 'react';

interface LocalId {
	useReadline?: boolean;
	readlineId?: string;
	readlineTitle?: string;
}

export interface LocalNavigationProps {
	contentId?: string | number;
	readlines?: LocalId[];
}

export const LocalNavigation: React.FC<LocalNavigationProps> = ({ readlines, contentId }) => {
	const { setTopValue } = useContext(LocalNavigationTopPositionContext);
	const rootUrl = window.location.origin;

	return (
		<LocalNavigationComponent
			id={contentId}
			getTopPosition={(top) => setTopValue(top)}
			navigationList={readlines?.map((link) => ({
				title: link.readlineTitle,
				id: link.readlineId,
				trackingEvent: {
					event: 'trackNavigation',
					navigationAction: link.readlineTitle ?? '',
					navigationDestination: `${rootUrl}/${link.readlineId ?? ''}`,
					navigationType: 'readline navigation menu',
				},
			}))}
		/>
	);
};
